import { PetitionEmbed } from "../../../../src/components/ctas/petition-embed.js";
import { AllSupervisorWithLocationEmailCTA } from "../../../../src/components/ctas/supervisor_email";
import { JFKCosponsors } from "../../../../src/components/issues/JFK/partners.js";
import * as React from 'react';
export default {
  PetitionEmbed,
  AllSupervisorWithLocationEmailCTA,
  JFKCosponsors,
  React
};